import Vue from "vue";
import * as firebase from "firebase";

import store from "./store";

const withAuth = (component ,required = true) => {
  return Vue.component("withAuth", {
    render(createElement) {
      return this.user || !required ? createElement(component) : null;
    },
    data() {
      return {
        user: undefined
      };
    },
    created() {
      firebase.auth().onAuthStateChanged(user => {
        store.dispatch("fetchUser", user);
        if (user) {
          this.user = user;
        } else if (required) {
          this.$router.replace({
            name: "login"
          });
        } else {
          console.log('User not logged in')
        }
      });
    }
  });
};

export default withAuth;
